module.exports = __webpack_public_path__ + "img/glenn-carstens-peters-P1qyEf1g0HU-unsplash.4954b21a.jpg";